import * as React from "react";
import * as Highlighter from "react-highlight-words";
import { LocStoreInstance } from ".";
import { UserInfo } from "../WSUtils/UserInfo";
import { loc } from "./loc";
import { splitStr, SplitStrReplacement } from "./splitStr";

export type SplitReplacement =
  | (JSX.Element | string | number)[]
  | ((s: string, index: number) => any);

export function split(
  s: string,
  replacements: SplitReplacement,
  searchWords: string[],
  stringContext: string,
  id: string,
  userInfo: UserInfo,
  locStoreInstance: LocStoreInstance
): any {
  const allReplacementsCanBeConvertedToString =
    Array.isArray(replacements) &&
    replacements.filter((r) => {
      const type = typeof r;

      return type === "string" || type === "number";
    }).length === replacements.length;

  if (
    (searchWords?.length ?? 0) === 0 &&
    allReplacementsCanBeConvertedToString
  ) {
    // use splitStr when possible because it returns a string instead of react objects
    return splitStr(
      s,
      replacements as SplitStrReplacement,
      searchWords,
      stringContext,
      id,
      userInfo,
      locStoreInstance
    );
  }

  s = loc(s, searchWords, stringContext, id, userInfo, locStoreInstance);

  const split = s.split(/(\{[^\}]+\})/);

  let _index = 0;
  return split
    .filter((s) => s)
    .map((s, index) => {
      try {
        let t: any = s;

        if (Array.isArray(replacements) && s.match(/\{\d+\}/)) {
          _index++;

          const index = Number(s.substring(1, s.length - 1));

          t = replacements[index];
        } else if (typeof replacements === "function") {
          let fMatch = s.match(/\{[^\}]+\}/);

          if (fMatch) {
            let _s = s.substring(1, s.length - 1);
            let replaced = replacements(_s, _index++);

            if (replaced !== undefined) t = replaced;
            else t = _s;
          }
        }

        if (searchWords && typeof t === "string") {
          return (
            <Highlighter
              key={`${s}_${index}`}
              searchWords={searchWords}
              autoEscape
              textToHighlight={t}
            />
          );
        }

        return <span key={`${s}_${index}`}>{t}</span>;
      } catch (e) {
        return s;
      }
    });
}
